import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed, min } from 'vee-validate/dist/rules';
import PhoneInput from '@/components/inputs/PhoneInput/PhoneInput.vue';
import DadataInput from '@/components/inputs/DadataInput/DadataInput.vue';
import PwdInput from '@/components/ui/inputs/PwdInput/PwdInput.vue';
import url from '@/validators/url.validator';
import config from '@/config';
import axios from 'axios';
import { sl } from 'date-fns/locale';

export default {
  data() {
    return {
      email: this.$route.query.email || null,
      firstName: this.$route.query.name || null,
      company: null,
      region: null,
      regionDadata: null,
      city: null,
      cityDadata: null,
      password: null,
      password_confirmation: null,
      contact_phone: null,
      website: null,
      terms: true
    };
  },

  computed: {
    agreementUrl: () => config.urls.agreement,
    policyUrl: () => config.urls.policy
  },

  methods: {
    getFieldValue(field) {
      return this[field.field];
    },

    changeFieldValue(fieldName, value) {
      this[fieldName] = value;
    },

    validateRegion(e) {
      const value = e.value ? e.value : '';
      const data = e.data ? e.data : null;
      this.region = value;
      this.regionDadata = data;
      this.$refs.regionProvider.syncValue(value);
      this.$refs.regionProvider.validate();
    },

    validateCity(e) {
      const value = e.value ? e.value : '';
      const data = e.data ? e.data : null;
      this.city = value;
      this.cityDadata = data;
      this.$refs.cityProvider.syncValue(value);
      this.$refs.cityProvider.validate();
    },

    validatePhone(e) {
      this.contact_phone = e;
      this.$refs.phoneProvider.syncValue(e);
      this.$refs.phoneProvider.validate();
    },

    validateCustomField(e, model, provider) {
      this[model] = e;
      this.$refs[provider].syncValue(e);
      this.$refs[provider].validate();
    },

    onPwdVisibilityToggle(e, slave) {
      this.$refs[slave].setPwdVisibility(e);
    },

    register() {
      const {
        email,
        firstName,
        company,
        contact_phone,
        website,
        region,
        regionDadata,
        city,
        cityDadata,
        password,
        password_confirmation: confirmation
      } = this;
      // const timezone = {};
      // Get timezone by geo data via Geonames API
      /* axios
        .get(
          `${config.api.geonames.tzUrl}?lat=${cityDadata.geo_lat}&lng=${cityDadata.geo_lon}&username=qwe`
        )
        .then(response => {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(response.data, 'text/xml');
          timezone.timezoneId = xmlDoc.getElementsByTagName(
            'timezoneId'
          )[0].childNodes[0].nodeValue;
          timezone.dstOffset = xmlDoc.getElementsByTagName(
            'dstOffset'
          )[0].childNodes[0].nodeValue;
          timezone.gmtOffset = xmlDoc.getElementsByTagName(
            'gmtOffset'
          )[0].childNodes[0].nodeValue;

          // Register with timezone
          this.dispatchRegistration(timezone);
        })
        .catch(error => {
          console.log(error);
          // Register with default timezone
        }); */
      this.dispatchRegistration(false);
    },

    dispatchRegistration(timezone) {
      const {
        email,
        firstName,
        company,
        contact_phone,
        website,
        region,
        city,
        password,
        password_confirmation: confirmation
      } = this;

      this.$store
        .dispatch('register', {
          email,
          contact_person: firstName,
          firmName: company,
          website,
          contact_phone,
          region,
          city,
          timezone,
          password,
          password_confirmation: confirmation
        })
        .then(() => {
          this.$router.push({ name: 'home' });
        })
        .catch(error => {
          if (error.response) {
            const { errors } = error.response.data;

            for (const errField in errors) {
              if (errors.hasOwnProperty(errField)) {
                const errorFieldErrors = errors[errField];

                errorFieldErrors.forEach(errorFieldError => {
                  this.flashError(errorFieldError);
                });
              }
            }
          }
        });
    }
  },

  created() {
    if (this.email === null) {
      window.location.replace(config.urls.registration);
    }
  },

  /* mounted() {
    // Fix autocomplete for DaData fields
    const cityInput = this.$refs.cityInput.$el.getElementsByTagName('input')[0];
    const regionInput = this.$refs.regionInput.$el.getElementsByTagName(
      'input'
    )[0];
    cityInput.setAttribute('autocomplete', 'no');
    regionInput.setAttribute('autocomplete', 'no');
  }, */

  components: {
    ValidationProvider,
    ValidationObserver,
    PhoneInput,
    DadataInput,
    PwdInput
  }
};

// Validation rules
extend('email', {
  ...email,
  message: 'Email указан не верно'
});

extend('required', {
  ...required,
  message: 'Обязательно'
});

extend('confirmed', {
  ...confirmed,
  message: 'Не совпадает'
});

extend('min', {
  ...min,
  message: 'Не короче 5 символов'
});

extend('url', {
  validate: url,
  message: 'Укажите корректный url-адрес'
});
